import React, { useState, useEffect, useRef } from "react";
import { NavLink, useParams } from "react-router-dom";
import {
  getSingleBookingById,
  getPartners,
  assignBookingToPartner,
  updateBookingRequestStatus,
  updateOrderQuotationDecision,
  getPrivateFileBlob,
  uploadTransitSingleFile,
  deleteOrderHistory,
} from "../Services/userService";
import { updateBookingStatus } from "../Services/bookingService";
import {
  logisticTypes,
  customStyles,
  STATUS_OPTIONS,
  RoutesPaths,
} from "../Router/constant";
import moment from "moment";
import { toast } from "react-toastify";
import Skeleton from "../Components/SkeletonLoader";
import ConfirmationModal from "../Components/ConfirmationModal";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { quotationFileUpload } from "../Services/bookingService";
import { CreateRoomMessage } from "../Services/messagesService";
import {
  generateDeliveryOrderPdf,
  generateWorkOrderPdf,
} from "../Utils/pdfGenerator";

export default function Bookingmanagementdetail() {
  const DELETE_ALLOWED_STATUSES = [
    "submitted for quote",
    "quote in place and sent to client for approval",
    "quote approved by client",
    "quote rejected by client",
    "order accepted",
    "in transit",
    "delivered",
  ];
  const [actionLoading, setActionLoading] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const fileInputRef = useRef(null);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const triggerRef = useRef(null);
  const [isQuotationUploaded, setIsQuotationUploaded] = useState(false);
  const handleIconClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  const navigate = useNavigate();
  const { id } = useParams();
  const [bookingData, setBookingData] = useState(null);
  const [acceptanceLoading, setAcceptanceLoading] = useState(null);
  const [quotationActionLoading, setQuotationActionLoading] = useState(false);
  const [quotationActionConfirmation, setQuotationActionConfirmation] =
    useState({
      show: false,
      quotation: null,
      status: "",
    });
  const [reasonQuotationMessage, setReasonQuotationMessage] = useState("");
  const [assignLoading, setAssignLoading] = useState(false);
  const [deleteConfirmation, setDeleteConfirmation] = useState({
    show: false,
    status: null,
  });
  const [partnersData, setPartnersData] = useState([]);
  const [selectedPartner, setSelectedPartner] = useState(null);

  useEffect(() => {
    if (id) fetchBookingData();
    if (id) fetchPartnerData();
  }, [id]);

  useEffect(() => {
    if (bookingData?.quotationPdf) {
      setIsQuotationUploaded(true);
    }
  }, [bookingData]);
  const userRole = localStorage.getItem("userRole");
  const fetchBookingData = async () => {
    try {
      const res = await getSingleBookingById(id);
      const order = res?.data?.data?.order || null;
      setBookingData(order);
      if (order?.assignPartner?._id) {
        setSelectedPartner(order.assignPartner._id);
      }
    } catch (error) {
      console.error("Error fetching booking:", error);
    }
  };

  const fetchPartnerData = async () => {
    try {
      const res = await getPartners(id);
      setPartnersData(res?.data?.data);
    } catch (error) {
      console.error("Error fetching partners:", error);
    }
  };
  const [deleteLoading, setDeleteLoading] = useState(false);
  const orderId = bookingData?.orderId;
  const trackNumber = bookingData?.trackNumber || "--";
  const name = bookingData?.name;
  const phoneNumber = bookingData?.phoneNumber;
  const logisticsType = bookingData?.logisticsType;
  const createdAt = bookingData?.createdAt;
  const productDetails = bookingData?.productDetails || [];
  const orderHistory = bookingData?.orderHistory || [];
  const status = bookingData?.status;
  const totalProducts = bookingData?.productDetails?.length || 0;
  const formattedDate = moment(createdAt).format("DD MMM YYYY, hh:mm A");
  const logisticsLabel = logisticTypes[logisticsType] || "N/A";

  const handleCopyToClipboard = (text) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text);
      toast.success("Copied to clipboard!");
    } else {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.setAttribute("readonly", "");
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      alert("Order ID copied to clipboard!");
    }
  };
  const [quotationFile, setQuotationFile] = useState();
  const [quotationLoader, setQuotationLoader] = useState(true);
  const [quotationLoading, setQuotationLoading] = useState(false);
  const handleQuotationFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const isImage = file.type.startsWith("image/");
    const isPdf = file.type === "application/pdf";

    if (!isImage && !isPdf) {
      toast.error("Only images or PDF files are allowed");
      return;
    }
    setQuotationFile(file);
    setIsQuotationUploaded(true); // <-- make bar green
    setQuotationLoader(false);
  };

  const handleQuotationSubmit = async () => {
    try {
      setQuotationLoading(true);
      const response = await quotationFileUpload(
        orderId,
        quotationFile,
        userRole,
      );
      toast.success(response?.data?.message);
      fetchBookingData();
      setQuotationLoader(true);
    } catch (err) {
      console.error("File upload failed:", err);
      toast.error(err?.response?.data?.data);
      setQuotationLoader(true);
      setQuotationLoading(false);
    } finally {
      setQuotationLoading(false);
    }
  };

  const handleQuotationCancel = () => {
    setQuotationFile(" ");
    setIsQuotationUploaded(false); // <-- make bar green
    setQuotationLoader(true);
  };

  const handleOpenPartnerQuotationAction = (quotation, status) => {
    setReasonQuotationMessage("");
    setQuotationActionConfirmation({
      show: true,
      quotation,
      status,
    });
  };

  const handleClosePartnerQuotationAction = () => {
    setQuotationActionConfirmation({
      show: false,
      quotation: null,
      status: "",
    });
    setReasonQuotationMessage("");
  };

  const handlePartnerQuotationAction = async () => {
    const { quotation, status } = quotationActionConfirmation;
    const quotationId =
      quotation?._id || quotation?.id || quotation?.quotationId;

    if (!quotationId || !status || quotationActionLoading) return;
    if (status === "rejected" && !reasonQuotationMessage.trim()) {
      toast.error("Please enter a rejection reason.");
      return;
    }

    setQuotationActionLoading(true);
    try {
      const response = await updateOrderQuotationDecision({
        orderId,
        isQuotationAccepted: status === "accepted",
        reasonQuotationMessage:
          status === "rejected" ? reasonQuotationMessage.trim() : "",
        quotationId,
      });
      toast.success(response?.data?.message || `Quotation ${status}`);
      fetchBookingData();
      handleClosePartnerQuotationAction();
    } catch (error) {
      console.error("Quotation status update failed:", error);
      toast.error(
        error?.response?.data?.message ||
          error?.response?.data?.data ||
          "Failed to update quotation status.",
      );
    } finally {
      setQuotationActionLoading(false);
    }
  };

  const handleAssignPartner = async () => {
    if (!selectedPartner) {
      toast.error("Please select a vendor first.");
      return;
    }

    setAssignLoading(true);
    try {
      const res = await assignBookingToPartner(id, selectedPartner);

      if (res?.data?.status === true) {
        toast.success("Order assigned to vendor successfully!");
        fetchBookingData(); // refresh data
      } else {
        toast.error(res?.data?.message || "Failed to assign vendor");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong while assigning vendor");
    }
    setAssignLoading(false);
  };

  const handleView = async (filename) => {
    const newTab = window.open("", "_blank");

    try {
      const res = await getPrivateFileBlob(filename);

      const blob = new Blob([res.data], {
        type: res.headers?.["content-type"] || "application/pdf",
      });

      const url = URL.createObjectURL(blob);
      newTab.location.href = url;

      setTimeout(() => URL.revokeObjectURL(url), 60_000);
    } catch (err) {
      newTab?.close();
      alert("Unable to open document (token invalid or file missing).");
    }
  };
  const confirmDeleteHistory = async () => {
    if (!deleteConfirmation.status) return;
    setDeleteLoading(true);
    try {
      const res = await deleteOrderHistory(
        bookingData._id,
        deleteConfirmation.status,
      );

      if (res?.data?.success === true) {
        toast.success("Order history deleted successfully!");
        fetchBookingData();
      } else {
        toast.error(res?.data?.message || "Delete failed");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong while deleting");
    }

    setDeleteLoading(false);
    setDeleteConfirmation({ show: false, status: null });
  };
  const handleResponse = async (acceptValue) => {
    if (acceptanceLoading) return;
    setAcceptanceLoading(acceptValue ? "accept" : "reject");
    try {
      const res = await updateBookingRequestStatus(id, acceptValue);
      toast.success(res.data.message);
      if (acceptValue === false) {
        navigate("/booking-management");
      } else {
        fetchBookingData();
      }
    } catch (error) {
      toast.error("Something went wrong!");
    } finally {
      setAcceptanceLoading(null);
    }
  };

  const normalize = (str) => {
    if (!str) return "";
    return str
      .toLowerCase()
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const normalizedLabel = normalize(logisticsLabel);

  const matchedPartners = partnersData.filter((partner) => {
    const hasMatchingService =
      Array.isArray(partner.serviceTypes) &&
      partner.serviceTypes.some((type) => normalize(type) === normalizedLabel);

    const isPartnerAccepted = partner.status === "accepted";

    const isContractAccepted =
      partner.partnershipContract?.status === "accepted";

    return hasMatchingService && isPartnerAccepted && isContractAccepted;
  });

  const lastQuotationWithPdf =
    bookingData?.quotation
      ?.slice()
      ?.reverse()
      ?.find((q) => q.quotationPdf) || null;

  const STATUS_LABEL = {
    accepted: "Accepted",
    rejected: "Rejected",
    opening: "Pending",
  };

  const STATUS_COLOR = {
    accepted: "#60B526",
    rejected: "#ff0000",
    opening: "#FFC22E",
  };

  const STATUS_OWNER = {
    opening: userRole === "partner" ? "Vendor :" : " Admin :",
    accepted: "User :",
    rejected: "User :",
  };

  const getQuotationStatusLabel = (item) => {
    return STATUS_LABEL[item.status] || "Pending";
  };

  const getQuotationStatusColor = (item) => {
    return STATUS_COLOR[item.status] || "#e9be20";
  };

  const getQuotationOwnerLabel = (item) => {
    return STATUS_OWNER[item.status] || "";
  };
  const quotationHistoryAll = bookingData?.quotation || [];
  const partnerQuotationHistory = bookingData?.partnerQuotation || [];
  const adminQuotationHistory = quotationHistoryAll.filter(
    (q) => q.uploadedBy === "" || q.uploadedBy === "admin",
  );
  const quotationHistory =
    userRole === "partner" ? partnerQuotationHistory : adminQuotationHistory;

  const getLastAcceptedQuotationByPartner = (quotationHistory) => {
    return quotationHistory
      ?.filter(
        (q) =>
          q.status === "accepted" &&
          (q.uploadedBy === "partner" || !q.uploadedBy),
      )
      ?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0];
  };
  const lastAcceptedPartnerQuotation = getLastAcceptedQuotationByPartner(
    partnerQuotationHistory,
  );
  const getLastAcceptedQuotationByAdmin = (quotationHistory) => {
    return quotationHistory
      ?.filter(
        (q) =>
          q.status === "accepted" &&
          (q.uploadedBy === "admin" || q.uploadedBy === ""),
      )
      ?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0];
  };
  const lastAcceptedAdminQuotation = getLastAcceptedQuotationByAdmin(
    adminQuotationHistory,
  );

  const lastQuotation = bookingData?.quotation?.at(-1) || null;
  const quotationStatus = lastQuotation?.isAcceptedQuotation;

  const [activeDropdown, setActiveDropdown] = useState(null);
  const [confirmationShipping, setConfirmationShipping] = useState({
    show: false,
    orderId: null,
    statusValue: "",
  });

  const toggleDropdown = (id) => {
    setActiveDropdown(activeDropdown === id ? null : id);
  };

  const handleStatusClick = (orderId, statusValue) => {
    setConfirmationShipping({
      show: true,
      orderId,
      statusValue,
      customStatus: statusValue?.toLowerCase() === "in transit" ? "" : null,
      messageText: statusValue?.toLowerCase() === "in transit" ? "" : null,
    });

    setActiveDropdown(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!activeDropdown) return;
      if (dropdownRef.current?.contains(event.target)) return;
      if (buttonRef.current?.contains(event.target)) return;
      setActiveDropdown(null);
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [activeDropdown]);
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setConfirmationShipping((prev) => ({
      ...prev,
      attachment: file,
    }));

    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await uploadTransitSingleFile(formData);

      if (response?.data?.status === true) {
        const fileName = response.data.data.fileName;

        setConfirmationShipping((prev) => ({
          ...prev,
          uploadedFileName: fileName,
        }));
      } else {
        toast.error("File upload failed");
      }
    } catch (error) {
      console.error("File upload error:", error);
      toast.error("File upload error");
    }
  };
  const handleConfirm = async () => {
    const { orderId, statusValue, customStatus, messageText } =
      confirmationShipping;

    const resetConfirmation = () => {
      setActiveDropdown(null);
      setConfirmationShipping({
        show: false,
        orderId: null,
        statusValue: "",
        customStatus: "",
        messageText: "",
        attachment: "",
      });
      setConfirmationShipping((prev) => ({
        ...prev,
        attachment: null,
      }));
    };
    // Build payload
    let payload;
    if (statusValue.toLowerCase() === "in transit") {
      payload = {
        status: "in transit",
        customStatus: customStatus || "",
        inTransitMessage: messageText || "",
        attachment: confirmationShipping.uploadedFileName || "",
      };
    } else {
      payload = { status: statusValue };
    }
    try {
      setConfirmLoading(true);
      const response = await updateBookingStatus(orderId, payload);

      if (response?.data?.status) {
        toast.success(response?.data?.data?.message);
        resetConfirmation();
        fetchBookingData();
      } else {
        resetConfirmation();
        toast.error(
          response?.data?.data?.message || "Failed to update order status.",
        );
      }
    } catch (error) {
      console.error("Update booking status error:", error);
      resetConfirmation();
      toast.error(
        error?.response?.data?.data?.message || "An unexpected error occurred.",
      );
    } finally {
      setConfirmLoading(false);
    }
  };
  const formatOrderStatus = (status = "") =>
    status.charAt(0).toUpperCase() + status.slice(1);

  const formatStatusBadge = (status) => {
    const map = {
      pending: "Pending",
      completed: "Completed",
      inprogress: "In-progress",
      "in progress": "In-progress",
      "in-transit": "In-transit",
      "in transit": "In-transit",
    };

    return map[status?.toLowerCase()] || status;
  };
  const hasAcceptedAdminQuotation = quotationHistory?.some(
    (q) => q.status === "accepted" && q.uploadedBy === "admin",
  );

  const handleChatType = async (type) => {
    const payload = {
      orderId: orderId,
      type: type,
    };

    try {
      const response = await CreateRoomMessage(payload);
      const roomId = getCreatedChatRoomId(response);
      const queryParams = new URLSearchParams({ type });

      if (roomId) {
        queryParams.set("roomId", roomId);
      }

      if (orderId) {
        queryParams.set("orderId", orderId);
      }

      if (
        response?.status === 200 ||
        response?.status === 201 ||
        response?.data?.success
      ) {
        navigate(`${RoutesPaths.ADMINMESSAGES}?${queryParams.toString()}`, {
          state: {
            chatType: type,
            roomId,
            orderId,
          },
        });
      }
    } catch (error) {
      toast.error("Unable to open chat.");
      console.error("Create chat room failed:", error);
    }
  };

  const handleDownloadPdf = async (order) => {
    try {
      await generateWorkOrderPdf(order);
    } catch (err) {
      toast.error(err.message || "Something went wrong");
    }
  };

  const handleDownloadDeliveryOrder = async (order) => {
    try {
      await generateDeliveryOrderPdf(order);
    } catch (err) {
      toast.error(err.message || "Something went wrong");
    }
  };

  const isDelivered = bookingData?.orderHistory?.some(
    (item) => item.status === "delivered" && item.completed,
  );
  return (
    <div className="container-fluid">
      <div className="row dashboardSection">
        <div className="col-md-12">
          <div className="logisticsMenuOuter mb-3">
            <div className="logisticsMenu logisticsMenuBooking">
              <p>
                <NavLink to={RoutesPaths.DASHBOARD}>
                  <img src="/assets/img/homeIcon.svg" alt="" />
                </NavLink>
              </p>
              <img src="/assets/img/chevron-right.svg" alt="" />
              <p>
                <NavLink
                  to={RoutesPaths.BOOKINGMANAGEMENT}
                  style={{ cursor: "pointer" }}
                >
                  Booking management
                </NavLink>
              </p>
              <img src="/assets/img/chevron-right.svg" alt="" />
              <p className="activeSegment">Order id : {orderId}</p>
            </div>

            <div className="btnPDfHeaderSection">
              {!bookingData ? (
                <Skeleton width={180} />
              ) : isDelivered ? (
                <div
                  className="btn btn-confirm"
                  onClick={() => handleDownloadDeliveryOrder(bookingData)}
                  style={{ cursor: "pointer" }}
                >
                  Delivery order
                </div>
              ) : (
                <div
                  className="btn btn-confirm"
                  onClick={() => handleDownloadPdf(bookingData)}
                  style={{ cursor: "pointer" }}
                >
                  Work order
                </div>
              )}

              {!bookingData ? (
                <Skeleton width={180} />
              ) : (
                <>
                  {userRole === "admin" && (
                    <div
                      className="btn btn-confirm"
                      onClick={() => handleChatType("user")}
                    >
                      Chat with user
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        <div className="col-md-12">
          {userRole === "partner" && bookingData?.isAccepted === null && (
            <div className="commonRightTrackingModal">
              <div>
                <h3 className="popupTitle">Booking request</h3>
                <p className="popupMessage">
                  Are you sure you want to accept this booking request?
                </p>

                <div className="popupActions">
                  <button
                    className="customCancelButtonReject"
                    onClick={() => handleResponse(false)}
                    disabled={Boolean(acceptanceLoading)}
                  >
                    {acceptanceLoading === "reject" ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Please wait...
                      </>
                    ) : (
                      "Reject"
                    )}
                  </button>
                  <button
                    className="customSaveButton"
                    onClick={() => handleResponse(true)}
                    disabled={Boolean(acceptanceLoading)}
                  >
                    {acceptanceLoading === "accept" ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Please wait...
                      </>
                    ) : (
                      "Accept"
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}

          {userRole === "admin" && hasAcceptedAdminQuotation === true && (
            <div className="commonRightTracking">
              <div className="ChatswithPartner">
                <div>
                  <div className="assignPartnerIcon">
                    <img src="/assets/img/assignPartner.svg" />
                    <h6 className="m-0">Assign vendor</h6>
                  </div>
                  <p>
                    Select and assign a vendor to this booking to ensure timely
                    service delivery and proper coordination.
                  </p>
                </div>

                <div
                  className={`btn btn-confirm ${
                    !bookingData?.assignPartner ? "disabledBtn" : ""
                  }`}
                  onClick={() => {
                    if (bookingData?.assignPartner) {
                      handleChatType("partner");
                    }
                  }}
                >
                  Chat with vendor
                </div>
              </div>

              {userRole === "admin" &&
                lastAcceptedAdminQuotation?.status === "accepted" &&
                (bookingData?.isAccepted === true ||
                  bookingData?.isAccepted === null) && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "15px",
                      marginBottom: "20px",
                      flexWrap: "wrap",
                    }}
                  >
                    {/* PRIORITY LOGIC HERE */}
                    {(() => {
                      const isDisabled =
                        !lastAcceptedAdminQuotation?.quotationPdf
                          ? true
                          : Boolean(bookingData?.assignPartner);

                      return (
                        <>
                          <div style={{ width: "250px" }}>
                            <Select
                              styles={customStyles}
                              options={matchedPartners?.map((partner) => ({
                                label: partner.companyName,
                                value: partner._id,
                              }))}
                              value={
                                matchedPartners
                                  ?.map((partner) => ({
                                    label: partner.companyName,
                                    value: partner._id,
                                  }))
                                  .find(
                                    (option) =>
                                      option.value === selectedPartner,
                                  ) || null
                              }
                              onChange={(selected) =>
                                setSelectedPartner(selected.value)
                              }
                              isDisabled={isDisabled}
                            />
                          </div>
                          <button
                            className="customSaveButton"
                            onClick={handleAssignPartner}
                            disabled={isDisabled}
                            style={{ opacity: isDisabled ? 0.5 : 1 }}
                          >
                            {assignLoading
                              ? "Please wait..."
                              : bookingData?.assignPartner &&
                                  lastAcceptedAdminQuotation?.status ===
                                    "accepted"
                                ? "Already assigned to vendor"
                                : "Assign order to vendor"}
                          </button>
                        </>
                      );
                    })()}
                  </div>
                )}

              {bookingData?.assignPartner && (
                <>
                  <div className="amountCreated d-flex">
                    <h6 className="m-0">Vendor company name :</h6>
                    <p className="m-0 ml-1">
                      {bookingData?.assignPartner?.companyName}
                    </p>
                  </div>

                  <div className="amountCreated d-flex">
                    <h6 className="m-0">Vendor email :</h6>
                    <p className="m-0 ml-1">
                      {bookingData?.assignPartner?.email}
                    </p>
                  </div>

                  <div className="amountCreated d-flex">
                    <h6 className="m-0">Vendor phone :</h6>
                    <p className="m-0 ml-1">
                      {bookingData?.assignPartner?.phone}
                    </p>
                  </div>
                </>
              )}
            </div>
          )}

          {bookingData ? (
            <>
              {userRole === "admin" && (
                <div className="commonRightTracking">
                  {quotationStatus ? (
                    <>
                      <h6 className="shipipngTitle">
                        Send quotation / document / file
                      </h6>
                      <div className="lc__card lc__cardRow">
                        <label
                          htmlFor="uploadQuotation"
                          className={`quotation-upload-label ${lastAcceptedAdminQuotation?.status === "accepted" ? "is-disabled" : ""}`}
                        >
                          <div className="quotation-upload-icon">
                            <img
                              src="/assets/img/progressIconContainer.svg"
                              alt="Upload"
                            />
                          </div>

                          <div className="quotation-upload-text">
                            <div className="quotation-upload-title">
                              Upload quotation / document / file
                            </div>
                            <div className="quotation-upload-subtitle">
                              File format: pdf,&nbsp;jpg,&nbsp;png,&nbsp;&nbsp;
                              File size: 5mb
                            </div>
                          </div>
                        </label>

                        {/* {lastAcceptedAdminQuotation?.quotationPdf && (
                          <span
                            className="lc__viewBtn"
                            onClick={() =>
                              handleView(
                                lastAcceptedAdminQuotation?.quotationPdf,
                              )
                            }
                          >
                            View
                          </span>
                        )} */}
                      </div>
                    </>
                  ) : (
                    <>
                      <h6 className="shipipngTitle">
                        Send quotation / document / file (Customer)
                      </h6>
                      <br />

                      <div className="productListSection mainOuterQuotation">
                        <div className="quotation-upload-wrapper-sendQuotation">
                          <div className="quotation-upload-row">
                            <label
                              htmlFor="uploadQuotation"
                              className={`quotation-upload-label ${
                                bookingData?.isAcceptedQuotation
                                  ? "is-disabled"
                                  : ""
                              }`}
                            >
                              <div className="quotation-upload-icon">
                                <img
                                  src="/assets/img/progressIconContainer.svg"
                                  alt="Upload"
                                />
                              </div>

                              <div className="quotation-upload-text">
                                <div className="quotation-upload-title">
                                  Upload quotation / document / file
                                </div>
                                <div className="quotation-upload-subtitle">
                                  File format: pdf, jpg, png&nbsp;&nbsp; File
                                  size: 5mb
                                </div>
                              </div>
                            </label>

                            {/* {lastAcceptedAdminQuotation &&
                              (lastAcceptedAdminQuotation.status ===
                                "accepted" ||
                                lastAcceptedAdminQuotation.status ===
                                "rejected") && (
                                <span
                                  className="lc__viewBtn"
                                  onClick={() =>
                                    handleView(
                                      lastAcceptedAdminQuotation.quotationPdf,
                                    )
                                  }
                                >
                                  View
                                </span>
                              )} */}
                          </div>

                          <div className="quotation-upload-progress">
                            <div
                              className={`quotation-upload-progress-bar ${
                                isQuotationUploaded ? "uploaded" : ""
                              }`}
                            />
                          </div>
                          {/* ))} */}

                          <input
                            id="uploadQuotation"
                            type="file"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            accept="image/*,application/pdf"
                            onChange={handleQuotationFileChange}
                          />
                        </div>
                      </div>
                      <div className="submitquotationOuter">
                        <button
                          className={`cancelQuotation  ${
                            quotationLoader ? "submitDisable" : ""
                          }`}
                          disabled={quotationLoader}
                          onClick={() => handleQuotationCancel()}
                        >
                          Cancel
                        </button>
                        <button
                          className={`submitQuotation ${quotationLoader || quotationLoading ? "submitDisable" : ""}`}
                          disabled={quotationLoader}
                          onClick={handleQuotationSubmit}
                        >
                          {quotationLoading ? (
                            <>
                              <span className="spinner" /> Submitting...
                            </>
                          ) : (
                            "Submit"
                          )}
                        </button>
                      </div>
                      {/* )} */}
                    </>
                  )}
                  {quotationHistory.length > 0 && (
                    <>
                      <div style={{ marginTop: 16 }} />
                      <h6 className="shipipngTitle">
                        Quotation / document / file status (Customer)
                      </h6>
                      <div className="trackOrderMap">
                        {bookingData ? (
                          quotationHistory?.length > 0 ? (
                            quotationHistory.map((event, index) => (
                              <div
                                className="orderTrackingDetails orderTrackingDetailsBottom"
                                key={index}
                              >
                                <div className="orderTrackShowSection orderQuotationSection">
                                  <div>
                                    <h6 className="m-0">
                                      {getQuotationOwnerLabel(event)} Quotation
                                      / document / file status{" "}
                                      <span
                                        className="quatationBadgeSize"
                                        style={{
                                          background:
                                            getQuotationStatusColor(event),
                                        }}
                                      >
                                        {getQuotationStatusLabel(event)}
                                      </span>
                                    </h6>
                                    <p className="m-0">{event.reason || "-"}</p>

                                    <p className="m-0 orderplaceTime">
                                      {moment(event.createdAt).format(
                                        "DD MMM YYYY, hh:mm A",
                                      )}
                                    </p>
                                  </div>

                                  <div
                                    className="viewAttatchment"
                                    onClick={() =>
                                      handleView(event?.quotationPdf)
                                    }
                                  >
                                    <img
                                      src="/assets/img/doc_icon.svg"
                                      alt=""
                                      style={{ marginBottom: "-2px" }}
                                    />
                                    View attachment
                                  </div>
                                </div>
                              </div>
                            ))
                          ) : (
                            <p>No quotation history available.</p>
                          )
                        ) : (
                          [...Array(3)].map((_, index) => (
                            <div className="orderTrackingDetails" key={index}>
                              <div className="approvedIcon">
                                <Skeleton circle width={20} height={20} />
                                <div className="verticalHr"></div>
                              </div>
                              <div className="orderTrackShowSection">
                                <Skeleton height={15} width={120} />
                                <Skeleton height={12} width={200} />
                                <Skeleton height={12} width={150} />
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    </>
                  )}
                </div>
              )}

              {/* vendor quotations for admin only */}
              {userRole === "admin" && partnerQuotationHistory.length > 0 && (
                <div className="commonRightTracking">
                  <h6 className="shipipngTitle">
                    Vendor quotation / document / file status
                  </h6>
                  <div className="trackOrderMap partnerQuotationStatusMap">
                    {partnerQuotationHistory.map((event, index) => {
                      const isLatestPartnerQuotation =
                        index === partnerQuotationHistory.length - 1;
                      const canActOnPartnerQuotation =
                        event?.status === "opening" && isLatestPartnerQuotation;

                      return (
                        <div
                          className="orderTrackingDetails orderTrackingDetailsBottom partnerQuotationStatusItem"
                          key={event?._id || index}
                        >
                          <div className="orderTrackShowSection orderQuotationSection partnerQuotationStatusRow">
                            <div>
                              <h6 className="m-0">
                                Vendor : Quotation status{" "}
                                <span
                                  className="quatationBadgeSize"
                                  style={{
                                    background: getQuotationStatusColor(event),
                                  }}
                                >
                                  {getQuotationStatusLabel(event)}
                                </span>
                              </h6>
                              <p className="m-0 pt-1">{event.reason || "-"}</p>

                              <p className="m-0 orderplaceTime">
                                {moment(event.createdAt).format(
                                  "DD MMM YYYY, hh:mm A",
                                )}
                              </p>
                            </div>

                            <div className="partnerQuotationStatusActions">
                              <button
                                type="button"
                                className="partnerQuotationViewAttachment"
                                onClick={() => handleView(event?.quotationPdf)}
                              >
                                <img
                                  src="/assets/img/doc_icon.svg"
                                  alt=""
                                  style={{ marginBottom: "-2px" }}
                                />
                                View attachment
                              </button>

                              {canActOnPartnerQuotation && (
                                <div className="quotationActionButtons">
                                  <button
                                    type="button"
                                    className="quotationActionButton quotationActionButtonReject"
                                    onClick={() =>
                                      handleOpenPartnerQuotationAction(
                                        event,
                                        "rejected",
                                      )
                                    }
                                    disabled={quotationActionLoading}
                                  >
                                    Reject
                                  </button>
                                  <button
                                    type="button"
                                    className="quotationActionButton quotationActionButtonAccept"
                                    onClick={() =>
                                      handleOpenPartnerQuotationAction(
                                        event,
                                        "accepted",
                                      )
                                    }
                                    disabled={quotationActionLoading}
                                  >
                                    Accept
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {userRole === "partner" && bookingData?.isAccepted === true && (
                <div className="commonRightTracking">
                  {quotationStatus ? (
                    <>
                      <h6 className="shipipngTitle">
                        Send quotation / document / file
                      </h6>
                      <div className="lc__card lc__cardRow">
                        <label
                          htmlFor="uploadQuotation"
                          className={`quotation-upload-label ${lastAcceptedPartnerQuotation?.status === "accepted" ? "is-disabled" : ""}`}
                        >
                          <div className="quotation-upload-icon">
                            <img
                              src="/assets/img/progressIconContainer.svg"
                              alt="Upload"
                            />
                          </div>

                          <div className="quotation-upload-text">
                            <div className="quotation-upload-title">
                              Upload quotation / document / file
                            </div>
                            <div className="quotation-upload-subtitle">
                              File format: pdf,&nbsp;jpg,&nbsp;png,&nbsp;&nbsp;
                              File size: 5mb
                            </div>
                          </div>
                        </label>

                        {/* {lastAcceptedPartnerQuotation?.quotationPdf && (
                          <span
                            className="lc__viewBtn"
                            onClick={() =>
                              handleView(
                                lastAcceptedPartnerQuotation?.quotationPdf,
                              )
                            }
                          >
                            View
                          </span>
                        )} */}
                      </div>
                    </>
                  ) : (
                    <>
                      <h6 className="shipipngTitle">
                        Send quotation / document / file
                      </h6>
                      <br />

                      <div className="productListSection mainOuterQuotation">
                        <div className="quotation-upload-wrapper-sendQuotation">
                          <div className="quotation-upload-row">
                            <label
                              htmlFor="uploadQuotation"
                              className={`quotation-upload-label ${
                                bookingData?.isAcceptedQuotation
                                  ? "is-disabled"
                                  : ""
                              }`}
                            >
                              <div className="quotation-upload-icon">
                                <img
                                  src="/assets/img/progressIconContainer.svg"
                                  alt="Upload"
                                />
                              </div>

                              <div className="quotation-upload-text">
                                <div className="quotation-upload-title">
                                  Upload quotation / document / file
                                </div>
                                <div className="quotation-upload-subtitle">
                                  File format: pdf, jpg, png&nbsp;&nbsp; File
                                  size: 5mb
                                </div>
                              </div>
                            </label>

                            {/* {lastAcceptedPartnerQuotation &&
                              (lastAcceptedPartnerQuotation.status ===
                                "accepted" ||
                                lastAcceptedPartnerQuotation.status ===
                                "rejected") && (
                                <span
                                  className="lc__viewBtn"
                                  onClick={() =>
                                    handleView(
                                      lastAcceptedPartnerQuotation.quotationPdf,
                                    )
                                  }
                                >
                                  View
                                </span>
                              )} */}
                          </div>

                          <div className="quotation-upload-progress">
                            <div
                              className={`quotation-upload-progress-bar ${
                                isQuotationUploaded ? "uploaded" : ""
                              }`}
                            />
                          </div>
                          {/* ))} */}

                          <input
                            id="uploadQuotation"
                            type="file"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            accept="image/*,application/pdf"
                            onChange={handleQuotationFileChange}
                            // disabled={
                            //   lastQuotationWithPdf?.status === "accepted"
                            // }
                          />
                        </div>
                      </div>
                      {/* {lastQuotationWithPdf?.status !== "accepted" && ( */}
                      <div className="submitquotationOuter">
                        <button
                          className={`cancelQuotation  ${
                            quotationLoader ? "submitDisable" : ""
                          }`}
                          disabled={quotationLoader}
                          onClick={() => handleQuotationCancel()}
                        >
                          Cancel
                        </button>
                        <button
                          className={`submitQuotation ${quotationLoader || quotationLoading ? "submitDisable" : ""}`}
                          disabled={quotationLoader}
                          onClick={handleQuotationSubmit}
                        >
                          {quotationLoading ? (
                            <>
                              <span className="spinner" /> Submitting...
                            </>
                          ) : (
                            "Submit"
                          )}
                        </button>
                      </div>
                      {/* )} */}
                    </>
                  )}
                  {quotationHistory.length > 0 && (
                    <>
                      <div style={{ marginTop: 16 }} />
                      <h6 className="shipipngTitle">Quotation status</h6>
                      <div className="trackOrderMap">
                        {bookingData ? (
                          quotationHistory?.length > 0 ? (
                            quotationHistory.map((event, index) => (
                              <div
                                className="orderTrackingDetails orderTrackingDetailsBottom"
                                key={index}
                              >
                                <div className="orderTrackShowSection orderQuotationSection">
                                  <div>
                                    <h6 className="">
                                      {getQuotationOwnerLabel(event)} Quotation
                                      status{" "}
                                      <span
                                        className="quatationBadgeSize"
                                        style={{
                                          background:
                                            getQuotationStatusColor(event),
                                        }}
                                      >
                                        {getQuotationStatusLabel(event)}
                                      </span>
                                    </h6>
                                    <p className="m-0">{event.reason || "-"}</p>

                                    <p className="m-0 orderplaceTime">
                                      {moment(event.createdAt).format(
                                        "DD MMM YYYY, hh:mm A",
                                      )}
                                    </p>
                                  </div>

                                  <div
                                    className="viewAttatchment"
                                    onClick={() =>
                                      handleView(event?.quotationPdf)
                                    }
                                  >
                                    <img
                                      src="/assets/img/doc_icon.svg"
                                      alt=""
                                      style={{ marginBottom: "-2px" }}
                                    />
                                    View attachment
                                  </div>
                                </div>
                              </div>
                            ))
                          ) : (
                            <p>No quotation history available.</p>
                          )
                        ) : (
                          [...Array(3)].map((_, index) => (
                            <div className="orderTrackingDetails" key={index}>
                              <div className="approvedIcon">
                                <Skeleton circle width={20} height={20} />
                                <div className="verticalHr"></div>
                              </div>
                              <div className="orderTrackShowSection">
                                <Skeleton height={15} width={120} />
                                <Skeleton height={12} width={200} />
                                <Skeleton height={12} width={150} />
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    </>
                  )}
                </div>
              )}
            </>
          ) : (
            <div className="commonRightTracking">
              <Skeleton height={40} width="100%" count={4} />
            </div>
          )}
          <div className="rightOrderIdSec commonRightTracking">
            <div>
              <div className="trackingId userDetails">
                <span>Order id</span>
                <p className="m-0 workOrderSectionOuter">
                  {bookingData ? (
                    <>
                      <div className="workOrderSection">
                        <p
                          className="orderIdActive m-0 cursorPointer"
                          onClick={() => handleDownloadPdf(bookingData)}
                          style={{ cursor: "pointer" }}
                        >
                          {orderId}
                        </p>
                        <span
                          className="orderIdCopy primaryColor"
                          onClick={() => handleCopyToClipboard(orderId)}
                          style={{ cursor: "pointer" }}
                        >
                          <img src="/assets/img/copyIcon.svg" alt="copy" /> Copy
                        </span>
                      </div>

                      {isDelivered ? (
                        <div
                          className="deliveryOrder"
                          onClick={() =>
                            handleDownloadDeliveryOrder(bookingData)
                          }
                          style={{ cursor: "pointer" }}
                        >
                          Delivery order
                        </div>
                      ) : (
                        <div
                          className="deliveryOrder"
                          onClick={() => handleDownloadPdf(bookingData)}
                          style={{ cursor: "pointer" }}
                        >
                          Work Order
                        </div>
                      )}
                    </>
                  ) : (
                    <Skeleton width={200} height={20} />
                  )}
                </p>
              </div>
              <div className="trackingId userDetails">
                <span>Track id</span>
                <p className="m-0">
                  {bookingData ? (
                    trackNumber
                  ) : (
                    <Skeleton width={200} height={20} />
                  )}
                </p>
              </div>
              <div className="trackingId userDetails">
                <span>Customer name</span>
                <p className="m-0">
                  {bookingData ? name : <Skeleton width={150} />}
                </p>
              </div>
              <div className="trackingId userDetails">
                <span>Phone number</span>
                <p className="m-0">
                  {bookingData ? phoneNumber : <Skeleton width={130} />}
                </p>
              </div>
            </div>
            <div>
              <div className="trackingId userDetails">
                <span style={{ textAlign: "end" }}>Date and time</span>
                <p className="m-0">
                  {bookingData ? formattedDate : <Skeleton width={180} />}
                </p>
              </div>
              <div className="trackingId userDetails">
                <span>Logistics type</span>
                <p className="m-0">
                  {bookingData ? (
                    logisticsLabel
                      .toLowerCase()
                      .replace(/_/g, " ")
                      .replace(/^./, (char) => char.toUpperCase())
                  ) : (
                    <Skeleton width={120} />
                  )}
                </p>
              </div>
              <div className="trackingId userDetails">
                <span>Status</span>
                <div className="m-0 statusWidth">
                  {bookingData ? (
                    <span
                      className={`badgeBooking ${status.toLowerCase().replace(/\s+/g, "")}Badge widthFitContent`}
                    >
                      {formatStatusBadge(status) || "N/A"}
                    </span>
                  ) : (
                    <Skeleton width={100} height={24} />
                  )}
                </div>
              </div>
              <div className="trackingId userDetails">
                <span>
                  Total {totalProducts.length > 1 ? "products" : "product"}
                </span>
                <p className="m-0">
                  {bookingData ? totalProducts : <Skeleton width={120} />}
                </p>
              </div>
            </div>
          </div>

          {(bookingData ? productDetails : Array(2).fill({})).map(
            (product, idx) => (
              <div className="commonRightTracking" key={idx}>
                <div className="productListSection">
                  <div className="productImage">
                    {bookingData ? (
                      <img
                        src={
                          product.image
                            ? `${process.env.REACT_APP_IMAGE_URL}/${product.image}`
                            : "/assets/img/default-image.jpg"
                        }
                        alt="Product"
                      />
                    ) : (
                      <Skeleton height={80} width={80} />
                    )}
                  </div>
                  <div className="productDescription">
                    {bookingData ? (
                      <>
                        <h6 className="m-0">
                          {product.name || "Unnamed Product"}
                        </h6>
                        <div className="quantityPriceOuter flex gap-2">
                          <div className="quantityPrice">
                            <p className="m-0">Quantity: {product?.quantity}</p>
                            <p className="m-0">Weight: {product?.weight} Kg</p>
                          </div>
                          <div className="quantityPrice">
                            <p className="m-0">
                              Height: {product.height} {product.heightOption}
                            </p>
                            <p className="m-0">
                              Width: {product.width} {product?.widthOption}
                            </p>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <Skeleton height={20} width={200} />
                        <Skeleton height={15} width={100} count={4} />
                      </>
                    )}
                  </div>
                </div>

                <div className="pickdropAddressOuter">
                  <div className="addressPickDrop">
                    <h6>Pickup address</h6>
                    <p className="m-0">{bookingData?.pickupAddress?.address}</p>
                    <div>
                      {bookingData?.pickupAddress?.houseNo && (
                        <p className="m-0 innerAddress">
                          {bookingData?.pickupAddress?.houseNo}
                        </p>
                      )}
                      {/* {bookingData?.pickupAddress?.city && (
                        <p className="m-0 innerAddress">
                          <span>City :</span> {bookingData?.pickupAddress?.city}
                        </p>
                      )}
                      {bookingData?.pickupAddress?.zipcode && (
                        <p className="m-0 innerAddress">
                          <span>Postal/Zip code :</span>{" "}
                          {bookingData?.pickupAddress?.zipcode}
                        </p>
                      )} */}
                    </div>
                  </div>
                  <div className="addressPickDrop">
                    <h6>Drop address</h6>
                    <p className="m-0">{bookingData?.dropAddress?.address}</p>
                    <div>
                      {bookingData?.dropAddress?.houseNo && (
                        <p className="m-0 innerAddress">
                          {bookingData?.dropAddress?.houseNo}
                        </p>
                      )}
                      {/* {bookingData?.dropAddress?.city && (
                        <p className="m-0 innerAddress">
                          <span>City :</span> {bookingData?.dropAddress?.city}
                        </p>
                      )}
                      {bookingData?.dropAddress?.zipcode && (
                        <p className="m-0 innerAddress">
                          <span>Postal/Zip code :</span>{" "}
                          {bookingData?.dropAddress?.zipcode}
                        </p>
                      )} */}
                    </div>
                  </div>
                </div>
              </div>
            ),
          )}

          <div className="commonRightTracking">
            <div className="updateShipingTextOuter">
              <h6 className="shipipngTitle">Shipping details</h6>
              <div className="updateShippingStatus">
                <button
                  ref={buttonRef}
                  type="button"
                  className={`btn btn-confirm ${
                    userRole === "partner" && !bookingData?.isAccepted
                      ? "disabledEditBooking"
                      : ""
                  }`}
                  onClick={() => toggleDropdown(bookingData?._id)}
                  disabled={userRole === "partner" && !bookingData?.isAccepted}
                >
                  Update shipping status
                </button>

                {activeDropdown === bookingData?._id && (
                  <div className="actionDropdown" ref={dropdownRef}>
                    <ul className="actionDropdownList">
                      {STATUS_OPTIONS.map((status) => {
                        const completedHistory =
                          bookingData?.orderHistory?.filter(
                            (h) => h.completed,
                          ) || [];
                        const latestCompleted =
                          completedHistory[
                            completedHistory.length - 1
                          ]?.status?.toLowerCase() || "";

                        return (
                          <li
                            key={status}
                            className={`actionDropdownItem ${latestCompleted === status?.toLowerCase() ? "selected" : ""}`}
                            onClick={() =>
                              handleStatusClick(bookingData?._id, status)
                            }
                          >
                            {status.toLowerCase() === "in transit"
                              ? "Other"
                              : status.charAt(0).toUpperCase() +
                                status.slice(1)}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}
              </div>
            </div>

            <div className="trackOrderMap">
              {bookingData ? (
                orderHistory.length > 0 ? (
                  orderHistory.map((event, index) => (
                    <div className="orderTrackingDetails" key={index}>
                      <div className="approvedIcon">
                        <img
                          src={
                            event.completed
                              ? "/assets/img/Step-Vertical.svg"
                              : "/assets/img/step-pending.svg"
                          }
                          alt=""
                        />
                        {index !== orderHistory.length - 1 && (
                          <div
                            className={
                              event.completed ? "verticalHr" : "verticalHrGrey"
                            }
                          ></div>
                        )}
                      </div>

                      <div
                        className="orderTrackShowSection orderTrackingDetailsBottom"
                        style={{ flex: 1, marginLeft: "10px" }}
                      >
                        <div className="shippingtitlDeleteSec">
                          <h6 className="m-0">
                            {event.customStatus ||
                              formatOrderStatus(event.status)}
                          </h6>

                          {DELETE_ALLOWED_STATUSES.includes(
                            event.status?.toLowerCase(),
                          ) &&
                            (["order accepted", "delivered"].includes(
                              event.status?.toLowerCase(),
                            )
                              ? event.completed
                              : true) && (
                              <div
                                style={{
                                  marginLeft: "auto",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  setDeleteConfirmation({
                                    show: true,
                                    status: event.status,
                                  })
                                }
                              >
                                <img
                                  src="/assets/img/delete-primary.svg"
                                  alt="delete"
                                  style={{ width: "20px", height: "20px" }}
                                />
                              </div>
                            )}
                        </div>
                        <p className="m-0">{event.message}</p>

                        {event?.attachment && (
                          <div
                            style={{ cursor: "pointer" }}
                            className="orderTrackingDetailsBottom viewAttachemntSec"
                          >
                            <span
                              className="viewAttatchment"
                              style={{ margin: "0px" }}
                              onClick={() =>
                                window.open(
                                  `${process.env.REACT_APP_IMAGE_URL}/${event.attachment}`,
                                  "_blank",
                                )
                              }
                            >
                              <img
                                src="/assets/img/doc_icon.svg"
                                alt=""
                                style={{ marginBottom: "-2px" }}
                              />
                              View attachment
                            </span>
                          </div>
                        )}
                        <p className="m-0 orderplaceTime">
                          {event?.timestamp
                            ? moment(event.timestamp).format(
                                "DD MMM YYYY, hh:mm A",
                              )
                            : "-"}
                        </p>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No order history available.</p>
                )
              ) : (
                [...Array(3)].map((_, index) => (
                  <div className="orderTrackingDetails" key={index}>
                    <div className="approvedIcon">
                      <Skeleton circle width={20} height={20} />
                      <div className="verticalHr"></div>
                    </div>
                    <div className="orderTrackShowSection">
                      <Skeleton height={15} width={120} />
                      <Skeleton height={12} width={200} />
                      <Skeleton height={12} width={150} />
                    </div>
                  </div>
                ))
              )}
              <ConfirmationModal
                show={deleteConfirmation.show}
                title="Delete order status"
                message="Are you sure you want to delete this order status."
                onConfirm={confirmDeleteHistory}
                onCancel={() =>
                  setDeleteConfirmation({ show: false, status: null })
                }
                confirmText={
                  deleteLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Deleting...
                    </>
                  ) : (
                    "Yes, delete"
                  )
                }
                cancelText="Cancel"
              />
              <ConfirmationModal
                show={quotationActionConfirmation.show}
                title={
                  quotationActionConfirmation.status === "accepted"
                    ? "Accept quotation"
                    : "Reject quotation"
                }
                message={
                  quotationActionConfirmation.status === "accepted"
                    ? "Are you sure you want to accept this vendor quotation?"
                    : null
                }
                onConfirm={handlePartnerQuotationAction}
                onCancel={handleClosePartnerQuotationAction}
                confirmText={
                  quotationActionLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Processing...
                    </>
                  ) : quotationActionConfirmation.status === "accepted" ? (
                    "Yes, accept"
                  ) : (
                    "Reject"
                  )
                }
                confirmDisabled={
                  quotationActionLoading ||
                  (quotationActionConfirmation.status === "rejected" &&
                    !reasonQuotationMessage.trim())
                }
                cancelText="Cancel"
                contentClassName={
                  quotationActionConfirmation.status === "rejected"
                    ? "rejectQuotationModal"
                    : ""
                }
              >
                {quotationActionConfirmation.status === "rejected" && (
                  <div className="rejectQuotationContent">
                    <p>
                      Are you sure you want to reject this quotation? This
                      action cannot be undone.
                    </p>
                    <textarea
                      value={reasonQuotationMessage}
                      onChange={(e) =>
                        setReasonQuotationMessage(e.target.value)
                      }
                      placeholder="Enter rejection reason..."
                      rows={4}
                      className="rejectQuotationTextarea"
                    />
                  </div>
                )}
              </ConfirmationModal>

              <ConfirmationModal
                show={confirmationShipping.show}
                title={
                  confirmationShipping.statusValue?.toLowerCase() ===
                  "in transit"
                    ? "Add custom tracking status"
                    : "Update status"
                }
                message={
                  confirmationShipping.statusValue?.toLowerCase() ===
                  "in transit" ? (
                    <div>
                      <p>
                        Please enter a custom tracking status for the user to
                        see:
                      </p>
                      <input
                        type="text"
                        placeholder="Custom tracking status"
                        value={confirmationShipping.customStatus || ""}
                        onChange={(e) =>
                          setConfirmationShipping({
                            ...confirmationShipping,
                            customStatus: e.target.value,
                          })
                        }
                        style={{
                          width: "100%",
                          marginBottom: "8px",
                          padding: "6px",
                        }}
                      />
                      <textarea
                        placeholder="Enter here message"
                        value={confirmationShipping.messageText || ""}
                        onChange={(e) =>
                          setConfirmationShipping({
                            ...confirmationShipping,
                            messageText: e.target.value,
                          })
                        }
                        style={{ width: "100%", padding: "6px" }}
                      />
                      <div
                        style={{
                          border: "2px dashed #d1d5db",
                          borderRadius: "6px",
                          padding: "12px",
                          textAlign: "center",
                          background: "#fafafa",
                        }}
                      >
                        <input
                          type="file"
                          name="file"
                          id="attachmentUpload"
                          ref={fileInputRef}
                          accept="image/*,application/pdf"
                          style={{ display: "none" }}
                          onChange={handleFileChange}
                        />
                        <label
                          htmlFor="attachmentUpload"
                          style={{
                            cursor: "pointer",
                            color: "#ff4d2d",
                            fontWeight: "500",
                          }}
                        >
                          Click to upload file
                        </label>

                        <p
                          style={{
                            fontSize: "12px",
                            color: "#888",
                            marginTop: "4px",
                          }}
                        >
                          PNG, JPG, PDF, DOC (Max 5MB)
                        </p>

                        {confirmationShipping?.attachment && (
                          <div
                            style={{
                              marginTop: "8px",
                              padding: "6px 10px",
                              background: "#f1f5f9",
                              borderRadius: "4px",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <span style={{ fontSize: "13px" }}>
                              📎 {confirmationShipping.attachment.name}
                            </span>

                            <button
                              type="button"
                              onClick={() => {
                                setConfirmationShipping((prev) => ({
                                  ...prev,
                                  attachment: null,
                                }));

                                setConfirmationShipping((prev) => ({
                                  ...prev,
                                  attachment: "",
                                }));
                              }}
                              style={{
                                border: "none",
                                background: "transparent",
                                color: "red",
                                cursor: "pointer",
                              }}
                            >
                              Remove
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    `Are you sure you want to update the status to "${confirmationShipping.statusValue.replace(
                      /\b\w/g,
                      (char) => char.toUpperCase(),
                    )}"?`
                  )
                }
                onConfirm={handleConfirm}
                onCancel={() =>
                  setConfirmationShipping({
                    show: false,
                    orderId: null,
                    statusValue: "",
                    customStatus: "",
                    messageText: "",
                    attachment: "",
                  })
                }
                confirmText={
                  confirmLoading ? (
                    <span className="confirm-loading">
                      <span className="confirm-spinner" />
                      Confirming...
                    </span>
                  ) : confirmationShipping.statusValue.toLowerCase() ===
                    "in transit" ? (
                    "Save status"
                  ) : (
                    "Confirm"
                  )
                }
                confirmDisabled={false}
                cancelText="Cancel"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function getCreatedChatRoomId(response) {
  const data = response?.data?.data ?? response?.data;
  const candidates = [
    data?.room?._id,
    data?.chatRoom?._id,
    data?.roomId,
    data?._id,
    data?.data?.room?._id,
    data?.data?.chatRoom?._id,
    data?.data?.roomId,
  ];

  return candidates.find(Boolean) || "";
}
